// Distribuição literal de S.6!I5:T13 em SUPERS.xlsx.
// Cada linha contém: dupla da esquerda (J,L) e dupla da direita (Q,S).
const Super6 = (() => {
  const rounds = Object.freeze([
    [[1, 6], [2, 4]],
    [[4, 5], [1, 3]],
    [[3, 5], [2, 6]],
    [[3, 6], [1, 2]],
    [[1, 5], [4, 6]],
    [[1, 4], [2, 3]],
    [[4, 5], [2, 6]],
    [[3, 4], [5, 6]],
    [[2, 5], [1, 3]],
  ]);

  function validGames(value) {
    return Number.isSafeInteger(value) && value >= 0;
  }

  function validConfig(config) {
    return config && ['sum', 'set'].includes(config.mode) && Number.isSafeInteger(config.target) && config.target > 0;
  }

  function scoreStatus(score, config) {
    if (!validConfig(config)) return 'pending';
    const left = score?.left;
    const right = score?.right;
    if (left == null && right == null) return 'pending';
    if ((left != null && (!validGames(left) || left > config.target)) ||
        (right != null && (!validGames(right) || right > config.target))) return 'invalid';
    if (left == null || right == null) return 'pending';
    if (config.mode === 'sum') return left + right === config.target ? 'complete' : 'invalid';
    return (left === config.target && right < config.target) ||
      (right === config.target && left < config.target) ? 'complete' : 'invalid';
  }

  function isComplete(score, config) {
    return scoreStatus(score, config) === 'complete';
  }

  function applyScoreInput(score, side, raw, config) {
    const next = { left: score?.left ?? null, right: score?.right ?? null };
    if (!['left', 'right'].includes(side)) return next;
    const other = side === 'left' ? 'right' : 'left';
    const value = raw === '' ? null : Number(raw);
    next[side] = value;
    if (!validConfig(config) || !validGames(value) || value > config.target) return next;
    if (config.mode === 'sum') next[other] = config.target - value;
    if (config.mode === 'set') {
      if (value < config.target) next[other] = config.target;
      else if (next[other] === config.target) next[other] = null;
    }
    return next;
  }

  function compareRankingEntries(a, b) {
    const averageDifference = (b.gameAverage || 0) - (a.gameAverage || 0);
    return b.points - a.points || b.wins - a.wins ||
      (Math.abs(averageDifference) > 1e-9 ? averageDifference : 0) ||
      b.position - a.position;
  }

  function sameRankingScore(a, b) {
    return a.points === b.points && a.wins === b.wins &&
      Math.abs((a.gameAverage || 0) - (b.gameAverage || 0)) <= 1e-9;
  }

  function standings(athletes, scores = [], config, schedule = rounds) {
    const size = athletes.length;
    const points = Array(size).fill(0);
    const played = Array(size).fill(0);
    const wins = Array(size).fill(0);
    const gameAverage = Array(size).fill(0);
    const headToHeadWins = Array.from({ length: size }, () => Array(size).fill(0));
    let completed = 0;
    schedule.forEach(([left, right], index) => {
      const score = scores[index];
      if (!isComplete(score, config)) return;
      completed += 1;
      const totalGames = score.left + score.right;
      left.forEach((position) => {
        points[position - 1] += score.left;
        played[position - 1] += 1;
        gameAverage[position - 1] += score.left / totalGames;
      });
      right.forEach((position) => {
        points[position - 1] += score.right;
        played[position - 1] += 1;
        gameAverage[position - 1] += score.right / totalGames;
      });
      const winners = score.left > score.right ? left : score.right > score.left ? right : [];
      winners.forEach((position) => { wins[position - 1] += 1; });
      if (winners.length) {
        const opponents = winners === left ? right : left;
        winners.forEach((winner) => opponents.forEach((opponent) => {
          headToHeadWins[winner - 1][opponent - 1] += 1;
        }));
      }
    });
    const ranking = athletes.map((name, index) => ({ position: index + 1, name, points: points[index], played: played[index], wins: wins[index], gameAverage: gameAverage[index] }));
    ranking.sort(compareRankingEntries);
    for (let start = 0; start < ranking.length;) {
      let end = start + 1;
      while (end < ranking.length && sameRankingScore(ranking[end], ranking[start])) end += 1;
      if (end - start > 1) {
        const tied = ranking.slice(start, end);
        const directWins = (entry) => tied.reduce((total, other) => total + headToHeadWins[entry.position - 1][other.position - 1], 0);
        const totals = new Map(tied.map((entry) => [entry.position, directWins(entry)]));
        tied.sort((a, b) => totals.get(b.position) - totals.get(a.position) || b.position - a.position);
        for (let groupStart = 0; groupStart < tied.length;) {
          let groupEnd = groupStart + 1;
          while (groupEnd < tied.length && totals.get(tied[groupEnd].position) === totals.get(tied[groupStart].position)) groupEnd += 1;
          if (groupEnd - groupStart === 2) {
            const pair = tied.slice(groupStart, groupEnd);
            pair.sort((a, b) => headToHeadWins[b.position - 1][a.position - 1] - headToHeadWins[a.position - 1][b.position - 1] || b.position - a.position);
            tied.splice(groupStart, 2, ...pair);
          }
          groupStart = groupEnd;
        }
        ranking.splice(start, tied.length, ...tied);
      }
      start = end;
    }
    return { ranking, completed };
  }

  return { rounds, validGames, validConfig, scoreStatus, isComplete, applyScoreInput, compareRankingEntries, standings };
})();

if (typeof globalThis !== 'undefined') globalThis.Super6 = Super6;
if (typeof module !== 'undefined') module.exports = Super6;
